module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/schedule-1-4-adaaf78ce4bbc6cb883bb588a6b68055.jpg";